<template>
  <section id="how-it-works" class="py-10">
    <div class="container mx-auto px-4">
      <div class="text-center mb-16">
        <h2 class="text-4xl md:text-5xl font-bold mb-4 gig-landing-text-purple">
          Nasıl Çalışır?
        </h2>
        <p class="text-lg text-gray-600 max-w-2xl mx-auto">
          Gigcep ile ödüller kazanmak çok kolay. Sadece bu üç adımı takip edin!
        </p>
      </div>

      <div class="relative">
        <div
          class="hidden md:block absolute top-1/2 left-[20%] right-[20%] h-0.5 bg-gradient-to-r from-indigo-200 via-purple-200 to-pink-200 transform -translate-y-1/2"
        />

        <div
          class="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto relative z-10"
        >
          <div
            v-for="(step, index) in steps"
            :key="step.id"
            class="card bg-white rounded-2xl shadow-xl border border-slate-100 p-8"
            data-aos="fade-up"
            :data-aos-delay="index * 100"
          >
            <div
              :class="`icon bg-[${step.color}] w-20 h-20 rounded-2xl flex items-center justify-center mb-6 mx-auto`"
              :style="{
                backgroundColor: step.color,
              }"
            >
              <Icon
                :name="step.icon"
                class="size-8 text-white transition-colors"
              />
            </div>
            <h3
              class="text-2xl font-bold mb-4 text-center block"
              :style="{
                minHeight: '65px',
              }"
            >
              {{ step.title }}
            </h3>
            <p class="text-gray-600 text-center text-lg">
              {{ step.description }}
            </p>
            <div class="mt-6 flex justify-center gig-landing-bg-purple">
              <span
                class="inline-flex items-center justify-center w-10 h-10 rounded-full text-white font-bold text-lg"
                :style="{
                  backgroundColor: '#4f46e5',
                }"
              >
                {{ step.id }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="text-center mt-10">
        <p class="text-xl text-gray-700 mb-8">
          Hemen şimdi başlayın ve ilk hediyenizi kazanın!
        </p>
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>
const steps = ref([
  {
    id: 1,
    title: "Uygulamayı İndir",
    description:
      "Google Play'den Gigcep uygulamasını ücretsiz olarak telefonunuza indirin.",
    icon: "material-symbols:download",
    color: "#4f46e5",
  },
  {
    id: 2,
    title: "Kayıt Ol",
    description:
      "Hızlı bir şekilde hesabınızı oluşturun ve profilinizi tamamlayın.",
    icon: "lucide:user-plus",
    color: "#9333ea",
  },
  {
    id: 3,
    title: "Talimatları Takip Et ve Kazanmaya Başla",
    description:
      "Basit gigleri tamamlayarak puanlar toplayın ve hediyeleri kazanın.",
    icon: "tabler:gift",
    color: "#db2777",
  },
])
</script>

<style scoped lang="scss">
#how-it-works {
  background-image: linear-gradient(to bottom, #f9fafb, #fff);

  .card {
    transition:
      transform 0.5s cubic-bezier(0.4, 0, 0.2, 1),
      box-shadow 0.5s cubic-bezier(0.4, 0, 0.2, 1);
    &:hover {
      transform: translateY(-10px);
      box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
      .icon {
        transform: rotate(6deg);
      }
    }

    .icon {
      transition: transform 0.5s cubic-bezier(0.4, 0, 0.2, 1);
    }
  }
}
</style>
